export default __webpack_public_path__ + "static/media/Vinayak Raj.f81147e9.jpg";